import Vue from "vue";
import "@/plugins/axios";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "@/plugins/element.js";
/**http */
import http from "@/libs/http";
/**LocalStorage 缓存 */
import cache from "@/libs/cache";
/**验证规则 */
import rules from "@/libs/rules";
/**公共方法*/
import "@/libs/publishPrototype";
Vue.config.productionTip = false;

Vue.prototype.$http = http;
Vue.prototype.$cache = cache;
Vue.prototype.$rules = rules;
// 版本1.0.20
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

window.JoinString = function(character, ...strArrays) {
  var res = [];
  if (strArrays.length > 0) {
    for (var item of strArrays) {
      if (item) {
        res.push(item);
      }
    }
  }
  return res.join(character);
};

/**复制数据 */
window.CopyData = function(sourceObj, targetObj, fields) {
  if (fields instanceof Array) {
    fields.forEach(field => {
      targetObj[field] = sourceObj[field];
    });
  } else {
    for (let field in targetObj) {
      targetObj[field] = sourceObj[field];
    }
  }
};
